import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MenuProduct from '../common/menu-product';
import ModifierQuantity from './modifier-quantity';

const { classNames } = Mobi2Go.helpers;

const SubProduct = ({
    menu_product,
    modifier_group,
    onSubProductQuantityAdd,
    onSubProductQuantityRemove,
    onSubProductEdit,
    quantity,
}) => {
    const { t } = useTranslation('product-editor');
    const { modifier_groups } = menu_product;
    const { selection_limit } = modifier_group;
    const class_name = classNames('m2g-product-editor-sub-product');

    const EditButton = () => {
        const can_edit = modifier_groups.length && quantity > 0;

        if (!can_edit) {
            return null;
        }
        return (
            <button
                className="m2g-button m2g-product-editor-sub-product-edit-button"
                tabIndex="0"
                type="button"
                onKeyDown={() => {}}
                onClick={() => {
                    onSubProductEdit(menu_product, modifier_group);
                }}
            >
                {t('sub-product-see-options')}
            </button>
        );
    };

    const AddedIndicator = () => {
        return (
            <div
                className={`${class_name}-added-indicator`}
                data-checked={quantity > 0}
                role="button"
                tabIndex="0"
                onKeyDown={() => {}}
                onClick={() => {
                    onSubProductQuantityRemove(menu_product, modifier_group);
                }}
            >
                <span
                    className={`${class_name}-added-indicator-icon m2g-icon m2g-icon--checkbox m2g-icon--tick`}
                />

                <span
                    className={`${class_name}-added-indicator-label m2g-text--small`}
                >
                    {t('sub-product-selected')}
                </span>
            </div>
        );
    };

    const AddButton = () => {
        return (
            <button
                type="button"
                className={`${class_name}-add-button m2g-button m2g-button--primary`}
                tabIndex="0"
                onKeyDown={() => {}}
                onClick={() => {
                    onSubProductQuantityAdd(menu_product, modifier_group);
                }}
            >
                {t('sub-product-select')}
            </button>
        );
    };

    const QuantitySelector = () => {
        return (
            <ModifierQuantity
                quantity={quantity}
                onChange={new_quantity => {
                    if (quantity > new_quantity) {
                        onSubProductQuantityRemove(
                            menu_product,
                            modifier_group
                        );
                    } else if (quantity < new_quantity) {
                        onSubProductQuantityAdd(menu_product, modifier_group);
                    }
                }}
                canIncrease
            />
        );
    };

    const StateControl = () => {
        const Content = () => {
            if (selection_limit === 1) {
                if (quantity > 0) {
                    return (
                        <>
                            <AddedIndicator />
                            <EditButton />
                        </>
                    );
                }
                return <AddButton />;
            }

            return (
                <>
                    <QuantitySelector />
                    <EditButton />
                </>
            );
        };

        return (
            <div className={`${class_name}-control`}>
                <Content />
            </div>
        );
    };

    return (
        <MenuProduct
            menu_product={menu_product}
            className={class_name}
            component={<StateControl />}
        />
    );
};

SubProduct.propTypes = {
    menu_product: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        backend_name: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        modifier_groups: PropTypes.array.isRequired,
        tags: PropTypes.array.isRequired,
        getProperty: PropTypes.func.isRequired,
        hasTag: PropTypes.func.isRequired,
        getSizeOptions: PropTypes.func.isRequired,
        getModifierGroups: PropTypes.func.isRequired,
    }).isRequired,
    modifier_group: PropTypes.shape({
        id: PropTypes.number.isRequired,
        selection_limit: PropTypes.number.isRequired,
    }).isRequired,
    quantity: PropTypes.number.isRequired,
    onSubProductQuantityAdd: PropTypes.func.isRequired,
    onSubProductQuantityRemove: PropTypes.func.isRequired,
    onSubProductEdit: PropTypes.func.isRequired,
};

export default SubProduct;
